import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  /* ===== Utilities kept intact ===== */
  smallPagination: {
    "& .MuiTablePagination-caption": { flexShrink: 0, fontSize: 12 },
    "& .MuiTablePagination-selectRoot": { fontSize: 12 },
    "& .MuiTablePagination-displayedRows": { fontSize: 12 },
    "& .MuiTablePagination-actions .MuiIconButton-root": { padding: 4 },
    "& .MuiTablePagination-actions svg": { fontSize: 16 },
  },
  modal: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  paper: { backgroundColor: '#fff', boxShadow: 'none' },

  inputRoot: {
    height: 32,
    padding: '5px 8px 6px 8px',
    borderRadius: 4,
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid rgba(213, 214, 221, 1)',
    },
  },
  inputRoot1: {
    height: 32,
    width: 250,
    padding: '5px 8px 6px 8px',
    borderRadius: 4,
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid rgba(213, 214, 221, 1)',
    },
  },

  /* ===== Banner / Section (Base ≈1920/≥1441) ===== */
  sectionPadding: { padding: 24, boxSizing: 'border-box' },

  banner: {
    height: 86,
    border: '1px dashed #3F51B5',
    borderRadius: 8,
    background: 'linear-gradient(90deg, #F8F9FF 24.76%, #F4F6FF 100%)',
    overflow: 'hidden',
    position: 'relative',
    padding: '24px 135px',
    boxSizing: 'border-box',
  },
  bannerImg: {
    height: 82,
    width: 82,
    position: 'absolute',
    transform: 'rotate(-10.26deg)',
    bottom: -7,
    left: 25,
  },
  bannerRow: { display: 'flex', gap: 12 },
  bannerBtn: {
    height: 36,
    width: 140,
    padding: 12,
    backgroundColor: 'transparent',
    borderRadius: 4,
    border: '1px solid #3F51B5',
    color: '#3F51B5',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    boxShadow: 'none',
    textTransform: 'none',
    '&&:hover': { backgroundColor: 'transparent', borderColor: '#3F51B5', boxShadow: 'none' },
  },
  bannerTextWrap: { display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0 },
  bannerSubHeading: {
    fontSize: 12, fontWeight: 400, lineHeight: '17px', color: 'rgba(69, 70, 83, 1)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%',
  },
  bannerTopHeading: {
    fontSize: 12, fontWeight: 400, lineHeight: '17px', color: 'rgba(146, 147, 166, 1)',
    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%',
  },

  /* ===== Table Section ===== */
  tableSection: {
    padding: '0 24px 24px 24px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  tableContainer: { boxShadow: 'none' },
  table: { width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' },
  tableHead: { backgroundColor: '#fff', height: 40 },

  tableHeaderCell: {
    padding: 8,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '17px',
    color: 'rgba(95, 96, 113, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 80,
    border: '1px solid rgba(233, 235, 245, 1)',
  },
  tableCell: {
    padding: 8,
    border: '1px solid rgba(233, 235, 245, 1)',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: 'rgba(95, 96, 113, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
  },
  cellContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
  },
  cellText: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: 'rgba(95, 96, 113, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
  },
  actionIcon: { width: 25, height: 25, cursor: 'pointer' },
  actionCell: { display: 'flex', justifyContent: 'center' },
  actionBtns: { display: 'flex', gap: 10, justifyContent: 'center' },

  /* Empty state */
  emptyWrap: { padding: 24, textAlign: 'center' },
  emptyText: { color: 'rgba(95, 96, 113, 1)', fontSize: 14, fontWeight: 400, lineHeight: '21px' },

  /* ===== ≤1440px ===== */
  '@media (max-width:1440px)': {
    sectionPadding: { padding: 22 },
    banner: { height: 84, padding: '22px 120px' },
    bannerImg: { height: 78, width: 78, bottom: -6, left: 18 },
    bannerRow: { gap: 12 },
    bannerBtn: { width: 136, height: 34, padding: 10, fontSize: 12, lineHeight: '16px' },
    bannerSubHeading: { lineHeight: '16px' },
    bannerTopHeading: { lineHeight: '16px' },

    tableSection: { padding: '0 22px 22px 22px', gap: 8 },
    tableHead: { height: 38 },
    tableHeaderCell: { fontSize: 12, maxWidth: 76, padding: 8 },
    tableCell: { fontSize: 12, maxWidth: 190, padding: 8 },
    cellText: { fontSize: 12, maxWidth: 190 },
  },

  /* ===== ≤1366px (new step) ===== */
  '@media (max-width:1366px)': {
    sectionPadding: { padding: 21 },
    banner: { height: 82, padding: '20px 110px' },
    bannerImg: { height: 74, width: 74, bottom: -6, left: 16 },
    bannerBtn: { width: 130, height: 32, padding: '8px 10px', fontSize: 12, lineHeight: '16px' },
    bannerSubHeading: { fontSize: 12 },
    bannerTopHeading: { fontSize: 12 },

    tableHead: { height: 36 },
    tableHeaderCell: { fontSize: 12, maxWidth: 74 },
    tableCell: { fontSize: 12, maxWidth: 185 },
    cellText: { fontSize: 12, maxWidth: 185 },
  },

  /* ===== ≤1280px ===== */
  '@media (max-width:1280px)': {
    sectionPadding: { padding: 20 },
    banner: { height: 80, padding: '18px 100px' },
    bannerImg: { height: 72, width: 72, bottom: -6, left: 16 },
    bannerRow: { gap: 10 },
    bannerBtn: { width: 124, height: 32, padding: '8px 10px', fontSize: 12, lineHeight: '16px' },

    tableSection: { padding: '0 20px 20px 20px', gap: 8 },
    tableHead: { height: 36 },
    tableHeaderCell: { fontSize: 12, maxWidth: 72, padding: 8 },
    tableCell: { fontSize: 12, maxWidth: 180, padding: 8 },
    cellText: { fontSize: 12, maxWidth: 180 },
  },

  /* ===== ≤1152px (new step) ===== */
  '@media (max-width:1152px)': {
    sectionPadding: { padding: 18 },
    banner: { height: 78, padding: '16px 92px' },
    bannerImg: { height: 68, width: 68, bottom: -6, left: 14 },
    bannerBtn: { width: 118, height: 31, padding: '6px 10px', fontSize: 11, lineHeight: '16px' },
    bannerSubHeading: { fontSize: 11, lineHeight: '16px' },
    bannerTopHeading: { fontSize: 11, lineHeight: '16px' },

    tableSection: { padding: '0 18px 18px 18px' },
    tableHead: { height: 34 },
    tableHeaderCell: { fontSize: 11, maxWidth: 70, padding: 8 },
    tableCell: { fontSize: 11, maxWidth: 175, padding: 8 },
    cellText: { fontSize: 11, maxWidth: 175 },
  },

  /* ===== ≤1024px ===== */
  '@media (max-width:1024px)': {
    sectionPadding: { padding: 14 },
    banner: { height: 72, padding: '14px 80px' },
    bannerImg: { height: 64, width: 64, bottom: -6, left: 12 },
    bannerRow: { gap: 10 },
    /* Button + text scaled down for 1024 */
    bannerBtn: { width: 112, height: 30, padding: '6px 10px', fontSize: 11, lineHeight: '16px' },
    bannerTextWrap: { gap: 3 },
    bannerSubHeading: { fontSize: 10, lineHeight: '15px' },
    bannerTopHeading: { fontSize: 10, lineHeight: '15px' },

    tableSection: { padding: '0 14px 14px 14px', gap: 8 },
    tableHead: { height: 32 },
    tableHeaderCell: { fontSize: 10, maxWidth: 64, padding: 8, lineHeight: '16px' },
    tableCell: { fontSize: 10, maxWidth: 168, padding: 8, lineHeight: '16px' },
    cellText: { fontSize: 10, maxWidth: 168, lineHeight: '16px' },
    emptyWrap: { padding: 14 },
    emptyText: { fontSize: 12, lineHeight: '18px' },
  },
}));

export default useStyles;

